// FUNÇÃO URL PÁGINA PRODUTO ORIGINAL
if (window.location.pathname == "naveia-deleite-de-aveia-original-1l") {
  console.log(window.location.pathname);
  document.getElementById("secMultiColuna").style.backgroundColor = "#24bee0";
}
if (window.location.pathname == "products/caixa-com-12-unidades-naveia-original") {
  console.log(window.location.pathname);
  document.getElementById("secMultiColuna").style.backgroundColor = "#24bee0";
}
// FUNÇÃO URL PÁGINA PRODUTO BARISTA
if (window.location.pathname == "/products/naveia-deleite-de-aveia-barista-1l") {
  console.log(window.location.pathname);
  document.getElementById("secMultiColuna").style.backgroundColor = "lightgray";
}
if (window.location.pathname == "/products/pack-com-12-unidades-naveia-barista") {
  console.log(window.location.pathname);
  document.getElementById("secMultiColuna").style.backgroundColor = "lightgray";
}